<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzFirstDemandCode"
      border
      auto-resize
      highlight-hover-row
      resizable
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:amzFirstDemandStatus="{ row }">
        <el-tag size="mini" effect="dark" :type="row.amzFirstDemandStatus">
          {{ row.v_amzFirstDemandStatus }}
        </el-tag>
      </template>
      <template v-slot:amzFtyPurchaseStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFtyPurchaseStatus == 'A'
              ? 'success'
              : row.amzFtyPurchaseStatus == 'B'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_amzFtyPurchaseStatus }}
        </el-tag>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag
          size="mini"
          v-if="row.v_skuSalesChannel"
          :type="row.skuSalesChannel == 'V' ? 'warning' : ''"
        >
          {{ row.v_skuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--S {
    color: #fa561f;
    background-color: #fff2e8;
    border: #ffbb96;
  }
  .el-tag--R {
    color: white;
    background-color: #3699fe;
    border: #007bff;
  }
  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
  .el-tag--B {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
  .el-tag--N {
    color: #6c6c6c;
    background-color: #bbbbbb;
    border-color: #bbbbbb;
  }
  .el-tag--Y {
    color: #70ce46;
    background-color: #f6ffed;
    border-color: #b7eb8f;
  }
}
</style>
